module.exports = __webpack_public_path__ + "static/img/help3.b9d671d9.png";